import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from './translation.pipe';
import { TranslationService } from './translation.service';
import { TranslatedNotificationService } from './translated-notification.service';

@NgModule({
    imports: [
      CommonModule
    ],
    exports: [
        TranslatePipe
    ],
    declarations: [
        TranslatePipe
    ],
    providers: [
        TranslationService,
        TranslatedNotificationService
    ]
})

export class TranslationModule {
}
